import React from "react";
import { Mic } from "lucide-react";
import { List, Tag, Task } from "../../types";
import { ProposedTodo } from "../../hooks/useVoiceToTodo";
import ProposedTodoReviewDialog from "./ProposedTodoReviewDialog";

interface VoiceReviewDialogProps {
  transcript: string;
  proposedTodos: ProposedTodo[];
  lists: List[];
  tags: Tag[];
  tasks?: Task[];
  onClose: () => void;
  onAccept: (todos: ProposedTodo[]) => void;
  maxTasks?: number;
  onUpgradeClick?: () => void;
}

const VoiceReviewDialog: React.FC<VoiceReviewDialogProps> = ({
  transcript,
  proposedTodos,
  lists,
  tags,
  tasks,
  onClose,
  onAccept,
  maxTasks,
  onUpgradeClick,
}) => (
  <ProposedTodoReviewDialog
    ariaLabel="Review Tasks"
    title="Review Tasks"
    countLabel={(n) => `${n} task${n !== 1 ? "s" : ""} extracted`}
    icon={
      <Mic size={20} className="text-warm-blue-dark dark:text-warm-blue" />
    }
    sourceLabel="Transcript"
    sourceText={transcript}
    initialTodos={proposedTodos}
    lists={lists}
    tags={tags}
    tasks={tasks}
    onClose={onClose}
    onAccept={onAccept}
    maxTasks={maxTasks}
    onUpgradeClick={onUpgradeClick}
    acceptLabel={(n) => `Add ${n} Task${n !== 1 ? "s" : ""}`}
  />
);

export default VoiceReviewDialog;
